import type { User } from '@paintscout/api'
import React from 'react'
import { useClientOptions } from '@paintscout/ui-business'
import { getCrews } from '@paintscout/util/builder'
import { removeAuth0Prefix } from '@paintscout/util/users'
import { useProductionCalendar } from '../ProductionCalendarContext'
import { CalendarEstimatorSelect } from '../../CalendarToolbar'

export default function ProductionCalendarEstimatorSelect() {
  const { selectedUsers, setSelectedUsers, tab } = useProductionCalendar()
  const { options } = useClientOptions()
  const crews = getCrews({ options })
  const userFilter = (user: User) => {
    const crew = crews.find((crew) => removeAuth0Prefix(crew.projectManager?.id) === removeAuth0Prefix(user.user_id))
    return !!crew
  }

  const handleClick = (user: User) => {
    if (selectedUsers.some((u) => u.user_id === user.user_id)) {
      setSelectedUsers(selectedUsers.filter((u) => u.user_id !== user.user_id))
    } else {
      setSelectedUsers([...selectedUsers, user])
    }
  }

  return (
    <CalendarEstimatorSelect selectedUsers={selectedUsers} tab={tab} onClick={handleClick} userFilter={userFilter} />
  )
}
